import { Modal, useMantineTheme } from '@mantine/core';
import type { ExecutionTrace } from '@bett3r-dev/teselly-rule-editor';
import React from 'react';
import {
  DryRunErrorPayload,
  HistoricalExecutionErrorPayload,
  RuleNodesView
} from './RuleNodesView';

type RuleNodesViewModalProps = {
  opened: boolean;
  onClose: () => void;
  dsl: unknown;
  executionTrace?: ExecutionTrace;
  /** Error information returned by the dry-run endpoint (node-level failure). */
  dryRunError?: DryRunErrorPayload;
  /**
   * Error information stored on a historical `RuleExecutionFailed` readmodel
   * document. See `RuleNodesView` for the remap behaviour.
   */
  historicalExecutionError?: HistoricalExecutionErrorPayload;
};

const RuleNodesViewModal: React.FC<RuleNodesViewModalProps> = ({
  opened,
  onClose,
  dsl,
  executionTrace,
  dryRunError,
  historicalExecutionError
}) => {
  const theme = useMantineTheme();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size={ theme.other.modalSizes.xxxl.width}
      padding={0}
      withCloseButton={true}
      closeButtonProps={{ size: 'md' }}
      styles={{
        body: {
          padding: 0
        },
        content: {
          minHeight: '80vh'
        },
        header: {
          padding: '10px 20px',
          justifyContent: 'flex-end'
        },
        close: {
          margin: '10px'
        }
      }}
    >
      <div style={{ padding: '20px', paddingTop: '0px', height: 'calc(80vh - 60px)' }}>
        <RuleNodesView
          dsl={dsl}
          executionTrace={executionTrace}
          dryRunError={dryRunError}
          historicalExecutionError={historicalExecutionError}
        />
      </div>
    </Modal>
  );
};

export default RuleNodesViewModal;
